import { render, staticRenderFns } from "./InventoryFilter.vue?vue&type=template&id=4b97e13f&scoped=true"
import script from "./InventoryFilter.vue?vue&type=script&lang=js"
export * from "./InventoryFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b97e13f",
  null
  
)

export default component.exports